/** "Today" or "5 Sep" for the Patients "Last visit" column. */
export function lastVisitLabel(iso: string | null) {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toDateString() === new Date().toDateString()
    ? 'Today'
    : d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
}
